import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const newsDiffusionEnum = {
  UPP: { label: "Par Upp" },
  ULTRA: { label: "Adhérents ULTRA" },
} as const satisfies ReferentialEnum
export const newsDiffusionReferential =
  referentialEnumToReferentialCodeList(newsDiffusionEnum)
export type NewsDiffusionName = keyof typeof newsDiffusionEnum
